

import cookiesMixin from '../../common/mixins/cookies-mixin';

const initMixin = {
  data() {
    return {
      queryString: {},
    };
  },
  computed: {

  },
  mounted() {
    this.checkForCDNPathParm();
    this.checkForASMorSEparam();
  },
  methods: {
    checkForCDNPathParm() {
      if (Object.prototype.hasOwnProperty.call(this.queryString, 'cdnpath')) {
        const cdnpathVal = this.queryString.cdnpath === 'localhost' ? '//localhost' : `//d2o3o2wreiygww.cloudfront.net/y/${this.queryString.cdnpath}`;
        const CookieDate = new Date();
        CookieDate.setFullYear(CookieDate.getFullYear() + 10);
        document.cookie = `cdnpath=${cdnpathVal};expires=${CookieDate.toUTCString()}; path=/`;
        delete this.queryString.cdnpath;

        if (Object.keys(this.queryString).length) {
          // if there are other query string params after cdnpath is deleted, add them back
          let newQueryString = '?';
          for (const prop in this.queryString) {
            if (this.queryString.hasOwnProperty(prop)) {
              newQueryString += `${prop}=${this.queryString[prop]}&`;
            }
          }
          window.location.search = newQueryString.slice(0, -1);
        } else {
          window.location = window.location.href.split('?')[0];
        }
      }
    },
    checkForASMorSEparam() {
      const isSmartEdit = window.location.href.indexOf('cmsTicketId') > -1;
      if (isSmartEdit) {
        const allResponsiveScript = document.createElement('script');
        const targetScriptTag = document.getElementsByTagName('HEAD');
        allResponsiveScript.setAttribute('type', 'text/javascript');
        allResponsiveScript.setAttribute('src', '/gp/wro/all_responsive.js');
        allResponsiveScript.onload = function() {
          const addonsResponsiveScript = document.createElement('script');
          addonsResponsiveScript.setAttribute('type', 'text/javascript');
          addonsResponsiveScript.setAttribute('src', '/gp/wro/addons_responsive.js');
          if (targetScriptTag && targetScriptTag.length > 0) { targetScriptTag[0].appendChild(addonsResponsiveScript); }
        };
        if (targetScriptTag && targetScriptTag.length > 0) { targetScriptTag[0].appendChild(allResponsiveScript); }
      }
    },
  },
  created() {
    const util = {
      parseQueryString: () => {
        if (window.location.search.length > 0) {
          const q = window.location.search.substring(1).split('&');
          if (q) {
            for (let i = 0; i < q.length; i++) {
              let P = q[i].split('='),
                key = decodeURIComponent(P[0]),
                value = decodeURIComponent(P[1]);
              this.queryString[key.toLowerCase()] = value;
            }
          }
        }
      },
    };
    util.parseQueryString();
  },
};

export default initMixin;



// WEBPACK FOOTER //
// ./src/components/common/mixins/init-mixin.js